module.exports = __webpack_public_path__ + "static/media/test18_1.4de2a61a.png";